export default "__VITE_ASSET__BCF0lpGx__"